var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1744,
    height: 1378,
    viewBox: "0 0 1744 1378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M541.757 1145.91C853.931 1386.15 1338.59 1433.93 1559.83 1314.41C1767.42 1202.27 1791.62 1003.72 1670.33 804.625C1509.46 540.595 1672.82 334.512 1502.28 132.238C1386.86 -4.63646 937.595 -77.3074 598.915 127.906C265.281 330.055 100.945 806.66 541.779 1145.92L541.757 1145.91Z",
    fill: "#EADEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8727 522.364C43.6787 243.029 271.055 39.6619 454.908 46.892C627.391 53.6774 752.61 185.792 801.714 369.22C866.821 612.457 1069.34 701.293 1094.4 904.138C1111.36 1041.45 916.669 1250.07 622.562 1223.2C332.866 1196.83 -23.4161 916.855 15.8727 522.364Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67827 617.993C-22.0603 332.04 146.637 95.1895 314.388 77.0412C471.762 60.0051 609.14 176.12 686.989 354.535C790.252 591.171 989.725 652.761 1049.39 854.201C1089.74 990.523 951.571 1228.16 680.492 1241.77C413.526 1255.2 40.0595 1021.75 3.67827 617.993Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack2);
export default __webpack_public_path__ + "static/media/back2.7e29e8c8fe41651a1da6b81df4231400.svg";
export { ForwardRef as ReactComponent };